/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DownpaymentSetup/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Loading from './Loading/index'
import Notes from './Notes/index'
import Pay from './Pay/index'
import React from 'react'
import Steps from './Steps/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DownpaymentSetup({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/DownpaymentSetup",
  isSubmitting
  
}) {
let payersIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payers',
})
  return (<React.Fragment
>
<div
  data-testid="DownpaymentSetup.Vertical"
  data-view-path={viewPath}
 style={{'--oy-1-1cRK45': payersIsSubmittingData ? "hidden" : "auto"}}
 className={`views-block ${styles.Vertical}`}
>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
<div
  data-testid="DownpaymentSetup.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<Steps
  viewPath={`${viewPath}/Steps`}
/>
<div
  data-testid="DownpaymentSetup.Vertical:2"
  data-view-path={viewPath}
 className="views-block"
>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
</div>
</div>
<Pay
  viewPath={`${viewPath}/Pay`}
/>
</div>
{children}
</React.Fragment>)
}